// extracted by mini-css-extract-plugin
export var chevron = "_gt-4";
export var chevronExpanded = "_gt-5";
export var row = "_gt-0";
export var rowBody = "_gt-6";
export var rowDescription = "_gt-7";
export var rowHeader = "_gt-1";
export var rowTitle = "_gt-2";
export var rowTitleComplete = "_gt-3";